import type { HTMLAttributes } from 'react';
import LoadingIcon from '@/assets/images/message/svg/messageStatusIcon_loading.svg?react';
import UnreadIcon from '@/assets/images/message/svg/messageStatusIcon_unread.svg?react';
import ReadIcon from '@/assets/images/message/svg/messageStatusIcon_read.svg?react';
import SuccessIcon from '@/assets/images/message/svg/messageStatusIcon_success.svg?react';
import ErrorIcon from '@/assets/images/message/svg/messageStatusIcon_error.svg?react';
import type { ChatMessage } from '@/contexts/chat/scripts/hooks/useChatMessages/types';
import { ChatMessageStatus } from '@/contexts/chat/scripts/hooks/useChatMessages/types';
import styles from './index.module.scss';

const icons = {
  [ChatMessageStatus.LOADING]: <LoadingIcon />,
  [ChatMessageStatus.UNREAD]: <UnreadIcon />,
  [ChatMessageStatus.READ]: <ReadIcon />,
  [ChatMessageStatus.SUCCESS]: <SuccessIcon />,
  [ChatMessageStatus.ERROR]: <ErrorIcon style={{ cursor: 'pointer' }} />,
  [ChatMessageStatus.REACH]: null,
  [ChatMessageStatus.PARTIAL_READ]: null,
};

interface MessageStatusIconProps extends HTMLAttributes<HTMLDivElement> {
  message: ChatMessage;
  className?: string;
}

export function SingleMessageStatus({
  className,
  message,
  ...props
}: MessageStatusIconProps) {
  return (
    <div className={cls(styles.messageStatusIcon, className)} {...props}>
      {icons[message.status]}
    </div>
  );
}
